import { render } from "./UserPanel.vue?vue&type=template&id=758fcb23&scoped=true"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"

import "./UserPanel.vue?vue&type=style&index=0&id=758fcb23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758fcb23"]])

export default __exports__